import { PlusIcon } from "@/shared/icons";
import type { FC } from "react";
import { AppParagraph } from "../../AppTypography";
import { AppButton } from "../../AppButton";
import styles from "./styles.module.scss";

type Props = {
  tabText?: string;
  onClick?: () => void;
};

export const AddTab: FC<Props> = ({ tabText, onClick }) => {
  return (
    <AppButton className={styles.root} onClick={onClick}>
      <AppParagraph className={styles["add-tab"]}>
        <PlusIcon className={styles["plus-icon"]} />
        <span>{tabText}</span>
      </AppParagraph>
    </AppButton>
  );
};
